import { render, staticRenderFns } from "./Returned.vue?vue&type=template&id=98d96b1c"
import script from "./Returned.vue?vue&type=script&lang=js"
export * from "./Returned.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports